import axios from 'axios';
import timerService from './timerService';

// Dynamically import the correct environment based on REACT_APP_ENV
export const getEnvironment = () => {
  const env = process.env.REACT_APP_ENV || process.env.NODE_ENV;
  
  if (env === 'test') {
    return require('../environments/environment.test').environment;
  } else if (env === 'production') {
    return require('../environments/environment.prod').environment;
  } else {
    return require('../environments/environment').environment;
  }
};

const API_BASE_URL = getEnvironment().apiUrl;

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  // timeout: 20000,
  withCredentials: true
});

// Request interceptor — reset session timer on every call except auth check
apiClient.interceptors.request.use((config) => {
  if (!config.url?.includes('authentication/properties')) {
    timerService.resetTimer();
  }
  return config;
});

// Response interceptor
apiClient.interceptors.response.use(
  (response) => {
    // Return successful responses as-is
    return response;
  },
  (error) => {
    const currentPath = window.location.pathname;
    
    if (error.response) {
      const user = localStorage.getItem('user');
      if ((error.response.status === 401 || error.response.status === 500) && user) {
        localStorage.removeItem('user');
        // Only reload if not already on login page
        if (currentPath !== '/login') {
          window.location.reload();
        }
      }
    }
    else{
      localStorage.removeItem('user');
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

export default apiClient;